/**
 * A role the learner has selected as a desired role. Either a catalog role
 * (resolved to an occupation id) or a free-text, user-generated role.
 */
export type SelectedRole = { type: 'DEFAULT'; id: string; name: string } | { type: 'CUSTOM'; name: string };

const normalize = (name: string) => name.trim().toLowerCase();

const isSameRole = (a: SelectedRole, b: SelectedRole): boolean => {
  if (a.type === 'DEFAULT' && b.type === 'DEFAULT') return a.id === b.id;
  if (a.type === 'CUSTOM' && b.type === 'CUSTOM') return normalize(a.name) === normalize(b.name);
  return false;
};

/** Add a role unless an equivalent one is already selected (idempotent). */
export const addRole = (roles: readonly SelectedRole[], role: SelectedRole): SelectedRole[] =>
  roles.some((existing) => isSameRole(existing, role)) ? [...roles] : [...roles, role];

/** Remove the given role (catalog by id, user-generated by name). */
export const removeRole = (roles: readonly SelectedRole[], role: SelectedRole): SelectedRole[] =>
  roles.filter((existing) => !isSameRole(existing, role));
